import { IFieldElem } from '@models/IFormData';
import { containsValue, getValueString } from '@utils/documentUtils';
import Chip from '@atoms/Chip';
import React, { FC, useMemo } from 'react';
import './DocumentModalTitle.scss';
import clsx from 'clsx';

export interface IDocumentModalTitleProps {
    titleText: string | undefined;
    fieldsData: Record<string, IFieldElem>;
}

const DocumentModalTitle: FC<IDocumentModalTitleProps> = ({ titleText, fieldsData }: IDocumentModalTitleProps) => {
    const statusText = useMemo(() => {
        return getValueString('|Document|Статус', fieldsData);
    }, [fieldsData]);

    return (
        <div className="doc-modal-header">
            <div className={clsx('doc-modal-header-el', 'doc-modal-header-txt')}>{titleText}</div>
            {containsValue('|Document|Статус', fieldsData) && statusText && (
                <div className={clsx('doc-modal-header-el', 'doc-modal-header-status', 'status-label')}>
                    <Chip type="fill" size="xs" isSelectableText={true} isButton={false}>
                        {statusText}
                    </Chip>
                </div>
            )}
        </div>
    );
};

export default DocumentModalTitle;
